import { BaseRoutes } from './base.routes.constants';

export class AntecipacaoConfirmationRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
